import { createFileRoute } from "@tanstack/react-router";
import TmsForSheriffsDeputies from "@/pages/TmsForSheriffsDeputies";
export const Route = createFileRoute("/tms-for-sheriffs-deputies")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "TMS For Sheriffs Deputies | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "TMS for sheriffs deputies facing depression and PTSD. Learn about first responder mental health treatment at Neuro Wellness TMS in Coral Springs, FL.",
        },
        {
          property: "og:title",
          content: "TMS For Sheriffs Deputies | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "TMS for sheriffs deputies facing depression and PTSD. Learn about first responder mental health treatment at Neuro Wellness TMS in Coral Springs, FL.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/tms-for-sheriffs-deputies",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/tms-for-sheriffs-deputies",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <TmsForSheriffsDeputies />;
}
